var levelOfAWSUsage = {
	"Level of AWS usage": "Nivel de uso de AWS",
	"Do not use AWS today": "No usa AWS en la actualidad",
	"Evaluating/experimenting with AWS": "Evaluando/experimentando con AWS",
	"Run dev/test workloads on AWS": "Ejecuta cargas de trabajo de desarrollo o pruebas en AWS",
	"Run a production workload on AWS": "Ejecuta una sola carga de trabajo de producción en AWS",
	"Run multiple production workloads on AWS": "Ejecuta múltiples cargas de trabajo de producción en AWS"
};

export { levelOfAWSUsage as default };
